import { getLeadScore } from "./leadScore";

/**
 * Suggest the highest-impact next step for a rep on this lead.
 * @returns {{ key: string, label: string, reason: string, priority: 'high'|'medium'|'low' } | null}
 */
export function getNextBestAction(lead = {}) {
  const status = String(lead.extra || "").toLowerCase();
  if (status === "converted" || status === "not interested") return null;

  const { tier } = getLeadScore(lead);
  const isNew = lead.mark === "New";
  const noContact = !lead.connected_time;

  if (lead.remainder_date && lead.remainder_time) {
    const due = Date.parse(
      `${String(lead.remainder_date).trim()}T${String(lead.remainder_time).trim().slice(0, 5)}:00+05:30`
    );
    if (!Number.isNaN(due)) {
      if (due <= Date.now()) {
        return {
          key: "follow_up",
          label: "Follow up now",
          reason: "Reminder is overdue",
          priority: "high",
        };
      }
      if (due - Date.now() < 2 * 60 * 60 * 1000) {
        return {
          key: "follow_up",
          label: "Follow up soon",
          reason: "Reminder due within 2 hours",
          priority: "medium",
        };
      }
    }
  }

  if (isNew && noContact) {
    return {
      key: "call",
      label: "Call now",
      reason: tier === "Hot" ? "Hot lead — no first contact yet" : "New lead — make first touch",
      priority: tier === "Hot" ? "high" : "medium",
    };
  }

  if (status === "pending") {
    return {
      key: "send_quote",
      label: "Send quotation",
      reason: "Pending stage — push quote to close",
      priority: "medium",
    };
  }

  if (status === "in progress" && !lead.remainder_date) {
    return {
      key: "schedule",
      label: "Set reminder",
      reason: "In progress — schedule next follow-up",
      priority: "low",
    };
  }

  if (noContact && tier === "Hot") {
    return {
      key: "call",
      label: "Call now",
      reason: "High-score lead still untouched",
      priority: "high",
    };
  }

  return {
    key: "note",
    label: "Log interaction",
    reason: "Keep the timeline up to date",
    priority: "low",
  };
}

export default getNextBestAction;
